import React, { forwardRef, ReactNode } from 'react';
import styled, { css } from 'styled-components';
import { theme } from '../../../styles/theme';
import { optionHover } from '../../../styles/shareableStyles';
import { IconName, SvgIcon } from '../../Icon';

interface IProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  iconName?: IconName;
  isActive?: boolean;
  isFocused?: boolean;
}

const Container = styled.button<{ $isActive?: boolean; $isFocused?: boolean }>`
  display: flex;
  align-items: center;
  column-gap: 8px;
  min-width: 0;
  width: 100%;
  height: 28px;
  padding-right: 8px;
  padding-left: 8px;
  font: inherit;
  font-size: 12px;
  font-weight: 400;
  color: ${theme.colors.secondary800};
  transition: color 225ms ease-in-out;
  outline: none;
  &:first-child {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }
  &:last-child {
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }
  &:not(:disabled):focus,
  &:not(:disabled):hover {
    cursor: pointer;
    ${optionHover};
  }
  &:disabled {
    color: ${theme.colors.secondary400};
    &:hover {
      background-color: unset;
      cursor: not-allowed;
      color: ${theme.colors.secondary400};
    }
  }
  ${({ $isActive }) =>
    $isActive &&
    css`
      color: ${theme.colors.mainBlue};
    `}
  ${({ $isFocused }) =>
    $isFocused &&
    css`
      cursor: pointer;
      ${optionHover};
    `}
`;

const StyledSingleSelectOption = forwardRef<HTMLButtonElement, IProps>(
  ({ children, iconName, isActive, isFocused, ...props }, ref) => {
    return (
      <Container
        ref={ref}
        {...props}
        type="button"
        $isActive={isActive}
        $isFocused={isFocused}
      >
        {iconName && (
          <SvgIcon
            name={iconName}
            width={14}
            height={14}
            customFill="currentColor"
          />
        )}
        {children}
      </Container>
    );
  },
);

export default StyledSingleSelectOption;
